import gql from 'graphql-tag';

import dokkioTagFragment from '../fragments/dokkioTagFragment';

export const mutationMergeDokkioTags = gql`
  mutation mergeDokkioTags (
    $primaryDokkioTagID: DokkioID!
    $secondaryDokkioTagID: DokkioID!
  ) {
    mergeDokkioTags (
      primaryDokkioTagID: $primaryDokkioTagID
      secondaryDokkioTagID: $secondaryDokkioTagID
    ) {
      ...dokkioTagFragment
    }
  }
  ${dokkioTagFragment}
`;

export default mutationMergeDokkioTags;
